module.exports = __webpack_public_path__ + "static/media/logo-fatiaprime.65942cb2.png";